import { render, staticRenderFns } from "./Setting8.vue?vue&type=template&id=0ae6a3fa&"
import script from "./Setting8.vue?vue&type=script&lang=js&"
export * from "./Setting8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports